module.exports = __webpack_public_path__ + "static/img/edge.9de2f353.png";